exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".btn-lg[data-v-127f6224]{font-size:70px}", "", {"version":3,"sources":["/Users/chakritkanpromkad/Desktop/Sourcetree/Mariminterfood/pos_ui-Develop/src/components/pos/paymentcredit.vue"],"names":[],"mappings":"AACA,yBACE,cAAgB,CACjB","file":"paymentcredit.vue","sourcesContent":["\n.btn-lg[data-v-127f6224] {\n  font-size: 70px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-127f6224","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/components/pos/paymentcredit.vue
// module id = 1268
// module chunks = 0